import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogVariantOptions } from 'shared/assets/styles';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './discard-changes-dialog.style';

export type DiscardChangesDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DiscardChangesDialog: React.FC<DiscardChangesDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      variant={DialogVariantOptions.ExtraSmall}
    >
      <Styled.DialogHeader>
        <Typography variant="h5" component="h1">
          {t('dialogs.task-detail.discard-changes.title')}
        </Typography>
      </Styled.DialogHeader>

      <Styled.DialogBody>
        <Typography variant="body2">
          {t('dialogs.task-detail.discard-changes.body')}
        </Typography>
      </Styled.DialogBody>

      <Styled.DialogFooter>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.White}
          onClick={onClose}
        >
          {t('dialogs.task-detail.discard-changes.cancel')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onConfirm}>
          {t('dialogs.task-detail.discard-changes.discard')}
        </Button>
      </Styled.DialogFooter>
    </Dialog>
  );
};
